var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Typography } from '@axafr-btc-ds/typography';
import React from 'react';
import * as css from './css';
import { DynamicIcon, IconSize } from '@axafr-btc-ds/icons';
export var isTabComponent = function (component) {
    return React.isValidElement(component) && component.props.label && component.props.panelId;
};
var MemoizedIcon = function (_a) {
    var iconName = _a.iconName;
    return React.useMemo(function () { return React.createElement(DynamicIcon, { className: css.tabIcon, iconName: iconName, size: IconSize.x2 }); }, [iconName]);
};
export var Tab = function (_a) {
    var label = _a.label, selected = _a.selected, panelId = _a.panelId, icon = _a.icon, iconName = _a.iconName, onClick = _a.onClick, className = _a.className, children = _a.children, props = __rest(_a, ["label", "selected", "panelId", "icon", "iconName", "onClick", "className", "children"]);
    return React.createElement("button", __assign({}, props, { key: label, type: "button", role: "tab", "aria-selected": selected, "aria-controls": panelId, className: className, onClick: function () { return onClick(panelId); } }),
        React.createElement(Typography, { className: css.tabLabel, variant: "body2" },
            iconName ? React.createElement(MemoizedIcon, { iconName: iconName }) : icon,
            label),
        children);
};
